<template>
  <div class="c-signature">
       <h1 class="c-users-information__title">{{ $t('usersInformation.stamp.title') }}</h1>
    <p class="c-users-information__text">{{ $t('usersInformation.stamp.fileExtension') }}</p>
    <div class="photo-div">
      <stamp-upload-view
        ref="stampUploadView"
        :privilegizedEntityId= "privilegizedEntityId"
        :stampIndex="1"
        @newUserStamp="cacheNewStamp"
      />
    </div>
    <div class="photo-div">
      <stamp-upload-view
        ref="stampUploadView1"
        :privilegizedEntityId= "privilegizedEntityId"
        :stampIndex="2"
        @newUserStamp="cacheNewStamp"
      />
    </div>
    <div class="photo-div">
      <stamp-upload-view
        ref="stampUploadView2"
        :privilegizedEntityId= "privilegizedEntityId"
        :stampIndex="3"
        @newUserStamp="cacheNewStamp"
      />
    </div>
  </div>

</template>
<script>
import StampUploadView from './StampUploadView'

export default{
  name: 'StampUser',
  components: {
    'stamp-upload-view': StampUploadView,
    'stamp-upload-view-1': StampUploadView,
    'stamp-upload-view-2': StampUploadView
  },
  data () {
    return {
      isNewStamp: false
    }
  },
  props: {
    privilegizedEntityId: {
      default: null,
      type: Number
    }
  },
  methods: {
    cacheNewStamp (newStamp, index) {
      let self = this
      self.isNewStamp = true
      self.userStamp = newStamp
      self.stampIndex = index
      self.$emit('userStamp', {
        isNewStamp: self.isNewStamp,
        stamp: self.userStamp,
        stampIndex: self.stampIndex})
    }

  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/Stamp.vue